import { UNIT_SIZE, UNIT_DRAW_SIZE } from "./constants/GameConstants";
import Isomer from "isomer";
// A flat marker ellipse on the ground under the unit, drawn only for units
// that are actually selected — the way an RTS shows what you have picked.
// Green for your own, amber for an enemy you have picked to look at. Without
// the distinction an inspected enemy wears the same ring as a unit you command,
// which is exactly the wrong thing to imply when it will not take orders.
export const SELECTED_OWN = "rgba(150, 245, 130, 0.95)";
export const SELECTED_ENEMY = "rgba(248, 194, 82, 0.95)";

export const drawSelectionMarker = (ctx, x, y, colour = SELECTED_OWN) => {
  ctx.lineWidth = 3;
  ctx.strokeStyle = colour;
  ctx.beginPath();
  ctx.ellipse(x, y + UNIT_DRAW_SIZE * 0.18, UNIT_DRAW_SIZE * 0.33,
              UNIT_DRAW_SIZE * 0.115, 0, 0, 2 * Math.PI);
  ctx.stroke();
};

// The control group key a selected unit answers to, set just off the right of
// the marker ellipse. Positioned from the same measurements the ellipse uses,
// so it follows if UNIT_DRAW_SIZE changes.
export const drawControlGroupLabel = (ctx, x, y, label) => {
  const centreY = y + UNIT_DRAW_SIZE * 0.18;
  const left = x + UNIT_DRAW_SIZE * 0.33 + 3;
  ctx.save();
  ctx.font = `bold ${Math.round(UNIT_DRAW_SIZE * 0.14)}px sans-serif`;
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  // Over grass, white on its own reads as mush. The dark outline is what makes
  // it legible without putting a badge behind it.
  ctx.lineWidth = 3;
  ctx.strokeStyle = "rgba(20, 26, 16, 0.85)";
  ctx.strokeText(label, left, centreY);
  ctx.fillStyle = "rgba(255, 255, 255, 0.95)";
  ctx.fillText(label, left, centreY);
  ctx.restore();
};

// The drag box is normalized so a selection made in any direction works, and
// padded by UNIT_SIZE so a plain click on a unit (a zero-area box) selects it.
export const rectContains = (x1, y1, x2, y2, x, y) => {
  const left = Math.min(x1, x2) - UNIT_SIZE;
  const right = Math.max(x1, x2) + UNIT_SIZE;
  const top = Math.min(y1, y2) - UNIT_SIZE;
  const bottom = Math.max(y1, y2) + UNIT_SIZE;
  return x >= left && x <= right && y >= top && y <= bottom;
};

export function* generateUnits(playerData) {
  /*   for (var player ) of Object.entries(playerData){
    for ([unitId, position]) of Object.entries {
       {pid: playerId; uid: unitId; position: position};
    });
  }); */
  for (let [playerId, player] of Object.entries(playerData)) {
    for (let [unitId, unit] of Object.entries(player.units)) {
      yield [playerId, unitId, player, unit];
    }
  }
}

export const drawGrid = (canvas) => {
  if (canvas) {
    let x,
      y,
      iso = new Isomer(canvas);
    for (x = 0; x < 10; x += 0.5) {
      iso.add(
        new Isomer.Path([
          new Isomer.Point(x, 0, 0),
          new Isomer.Point(x, 100, 0),
          new Isomer.Point(x, 0, 0),
        ]),
        new Isomer.Color(50, 60, 160)
      );
    }
    for (y = 0; y < 10; y += 0.5) {
      iso.add(
        new Isomer.Path([
          new Isomer.Point(0, y, 0),
          new Isomer.Point(10, y, 0),
          new Isomer.Point(0, y, 0),
        ]),
        new Isomer.Color(50, 60, 160)
      );
    }
  }
};
